import stockChildren from '../../../../../../assets/images/stock-children2.jpg'

export default makeStyles((theme) => ({
  westminsterContainer: (props) => ({
    padding: '55px 25px 65px 25px',
    margin: 0,
    maxWidth: `${screen.width}px`,
    position: 'relative',
    '&::before': {
      content: `""`,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'block',
      position: 'absolute',
      background: `url(${stockChildren})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      filter: 'contrast(10%) sepia(100%) hue-rotate(145deg) brightness(1) saturate(3.28)',
    },
  }),
  container: () => ({
    backgroundColor: '#d40e8c',
    padding: '55px 25px 65px 25px',
    margin: 0,
    maxWidth: '100vw',
  }),
  storyContainer: {
    padding: '40px',
  },
  highlight: {
    color: theme.palette.secondary.main,
  },
  bright: {
    color: 'white',
    margin: '15px 0',
  },
  mpImage: (props) => ({
    width: props.desktop ? 350 : '60%',
    height: props.desktop ? 350 : 'auto',
    padding: 0,
    borderRadius: props.desktop ? 175 : '50%',
    maxWidth: 350,
    maxHeight: 350,
    boxShadow: '0px 0px 20px 3px rgb(0 0 0 / 12%)',
  }),
  mpDetails: (props) => ({
    alignSelf: 'center',
    textAlign: 'center',
    position: 'relative',
    margin: props.desktop ? 0 : '32px 0',
  }),
  mpName: {
    color: 'white',
    marginBottom: -10,
  },
  facts: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  action: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  image: {
    maxHeight: 600,
    paddingBottom: 5,
    [theme.breakpoints.down('md')]: {
      maxHeight: '40vh',
    },
  },
  fragment: {
    paddingTop: 15,
  },
  button: ({ desktop }) => ({
    marginTop: 20,
    paddingLeft: desktop ? 60 : 'inherit',
    paddingRight: desktop ? 60 : 'inherit',
  }),
  colouredBlock: {
    width: '100%',
    backgroundColor: '#d40e8c',
    height: '275px',
  },
  pledgeBox: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20,
  },
  pledgeStatus: {
    background: 'white',
    padding: '4px 10px',
    textAlign: 'center',
  },
  pledgeHighlight: {
    color: theme.palette.secondary.main,
  },
  pledgeIntro: {
    fontSize: 16,
    color: 'white',
    padding: 0,
  },
}))
